import React, { useState, useEffect, useContext } from "react";
//import PropsLoader from './PropsLoader';
import MyContext from "../context/MyContext";
import TickerContext from "../context/ticker";
import AuthContext from "../context/userAuth.context";
import UpdateTags from "./UpdateTags";
import Swal from "sweetalert2";
import axios from "axios";

function AssetSearch(props) {
  const { Goto, setGoto, TickerPosition } = useContext(TickerContext);
  const [open, setOpen] = useState(false);
  const { authenticationData, Role } = useContext(AuthContext);

  const [itemId, setItemId] = useState(0);
  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );
  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    calculateWidthByDuration,
    ChangeCount,
    setChangeCount,
    Tl_TotalTime,
    EditorZoom,
    seteditableObject,
  } = useContext(MyContext);

  const setObjectPopup = (photos) => {
    setOpen(true);
    setItemId(photos.target.id);
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const addshape = (e, url) => {
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let _widthPercentage = e.target.offsetWidth / 1024;
    let _heightPercentage = e.target.offsetHeight / 593;
    let _width = CanvasWidth * _widthPercentage;
    let _height = canvasHeight * _heightPercentage;

    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    var stack = [...UndoLayer];
    var PrevArray;
    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    if (Goto.innerMenu == "shape") {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === Goto.key) {
          array[i].ShapePath = url;
          array[i].width = e.target.offsetWidth;
          array[i].height = e.target.offsetHeight;
        }
      }
      setLayersData(array);
      setChangeCount(ChangeCount + 1);
      setGoto({
        menu: null,
        innerMenu: null,
        key: null,
      });
    } else {
      var topIndex = 0;
      if (LayersData.length > 0) {
        topIndex = LayersData[LayersData.length - 1].layerIndex;
        topIndex = topIndex + 1;
      }

      var typelength = 1;

      var checkKey = 0;

      for (var i = 0; i < LayersData.length; i++) {
        if (LayersData[i].Editable === true) {
          LayersData[i].Editable = false;
          LayersData[i].showDiv = false;
        }
        LayersData[i].toolbar = false;

        if (LayersData[i].type === "Shape") {
          typelength = typelength + 1;
        }
        if (LayersData[i].key >= checkKey) {
          checkKey = LayersData[i].key;
        }
      }

      // let TickPos
      // let trans = document.getElementById('tickerHead').style.transform
      // if (trans != "") {
      //     trans = trans.split('(')
      //     trans = trans[1].split(',')
      //     trans = trans[0].split('px')
      //     trans = eval(trans[0]);
      //     TickPos = trans
      // }

      let currentTime = calculateTimeByWidth(TickerPosition);
      let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

      let newEntryLayerData = {
        key: checkKey + 1,
        type: "Shape",
        bgColor: "#838383",
        AnimationId: makeid(7),
        Name: `Shape-${typelength}`,
        canvas: null,
        video: null,
        TimelineZoom: timelineZoomVal,
        userFile: "xyz",
        layerIndex: topIndex,
        index: null,
        duration: totalTime,
        startTime: currentTime,
        endTime: calculateTimeByWidth(Tl_TotalTime.width),
        volume: null,
        visible: true,
        OutEffect: "none",
        InEffect: "none",
        typeIcon: "vrpano",
        startTransitionWidth: 0,
        startTransitionLeft: 0,
        endTransitionWidth: 0,
        endTransitionLeft: 0,
        angle: 0,
        ShapePath: url,
        crop: "false",
        lock: false,
        x: left,
        y: top,
        flip: "scaleX(1)",
        width: _width,
        height: _height,
        toolbar: true,
        FurtherSetting: false,
        opacity: 1,
        originalOpacity: 1,
        layerlock: false,
        opc: 1,
        hidden: false,
        Editable: true,
        startPositionOnTimeline: TickerPosition,
        player: false,
        showDiv: true,
        rotateAngle: 0,
        InMultiDrag: false,
      };
      newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
        newEntryLayerData.duration
      );

      newEntryLayerData.endTransitionLeft =
        newEntryLayerData.widthOnTimeline -
        newEntryLayerData.endTransitionWidth;
      setLayersData(LayersData.concat(newEntryLayerData));
      setChangeCount(ChangeCount + 1);
      seteditableObject({
        showPanel: true,
        editableItem: newEntryLayerData,
      });
    }
  };

  const deleteShape = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        var formdata = new FormData();

        formdata.append("id", e.target.id);
        axios
          .post(
            authenticationData.ApiBaseURL + "/api/Administration/deleteShape",
            formdata,
            {
              headers: {
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.response == "Success") {
              props.getObjectFolderDataBykeyword(props.searchKeyword);
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
              Swal.fire("Deleted!", "Not deleted", "Failed");
            }
          })
          .catch((excetion) => {
            console.log(excetion);
          });
      }
    });
  };

  return (
    <>
      <div className="Character_folder_items">
        <div style={{ width: "100%", height: "auto" }}>
          <div className="Char_assetsList">
            {props.type == "Objects" && props.item.length > 0 && (
              <div className="d-flex" style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  {props.item.map((photos, index) => {
                    return (
                      <div
                        key={index}
                        className="dragdivParent shapesBack"
                        style={{
                          display: "inline-block",

                          textAlign: "center",
                        }}
                      >
                        {Role == "admin" && (
                          <>
                            <div
                              className="adminIconsUpload"
                              title="Admin Edit Prop"
                              style={{ zIndex: 1 }}
                            >
                              <span
                                id={photos.id}
                                className="material-icons"
                                onClick={(e) => setObjectPopup(e)}
                                style={{ fontSize: "14px", lineHeight: "12px" }}
                              >
                                edit
                              </span>
                            </div>
                            <div
                              className="adminIconsDelete"
                              title="Admin Prop Delete"
                              style={{ zIndex: 1 }}
                            >
                              <span
                                id={photos.id}
                                className="material-icons"
                                onClick={deleteShape}
                                style={{ fontSize: "14px", lineHeight: "12px" }}
                              >
                                delete
                              </span>
                            </div>
                          </>
                        )}
                        <div
                          style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "25px",
                          }}
                        >
                          <img
                            key={"img" + photos.id}
                            src={
                              authenticationData.ApiBaseURL + "/" + photos.path
                            }
                            alt=""
                            draggable={false}
                            style={{
                              padding: "2px",
                              borderRadius: "7px",
                              width: "100%",
                              height: "100%",
                              position: "absolute",
                              left: "0px",
                            }}
                            onClick={(e) => {
                              addshape(e, photos.path);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* <div style={{ width: "50%" }}>
                    {props.item.map((photos, index) => {
                      return (
                        index % 2 != 0 && (
                          <div
                            key={index}
                            className="dragdivParent ShapeHover"
                            style={{
                              display: "inline-block",
                              width: "163px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100px",
                                borderRadius: "25px",
                              }}
                            >
                              <span
                                id={photos.id}
                                onClick={(e) => setObjectPopup(e)}
                                className="material-icons"
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  right: "0px",
                                  color: "#9f9393",
                                }}
                              >
                                edit
                              </span>
                              <span
                                onClick={deleteShape}
                                id={photos.id}
                                className="material-icons"
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  right: "25px",
                                  color: "#9f9393",
                                }}
                              >
                                delete
                              </span>
                              <img
                                key={"img" + photos.id}
                                src={
                                  authenticationData.ApiBaseURL +
                                  "/" +
                                  photos.path
                                }
                                alt=""
                                draggable={false}
                                style={{
                                  padding: "2px",
                                  borderRadius: "7px",
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                }}
                                onClick={(e) => {
                                  addshape(
                                    e,
                                    authenticationData.ApiBaseURL +
                                      "/" +
                                      photos.path
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div> */}
              </div>
            )}
            {props.type == "Shapes" && props.item.length > 0 && (
              <div className="d-flex" style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  {props.item.map((photos, index) => {
                    return (
                      <div
                        key={index}
                        className="dragdivParent shapesBack"
                        style={{
                          display: "inline-block",

                          textAlign: "center",
                        }}
                      >
                        {Role == "admin" && (
                          <>
                            <div
                              className="adminIconsUpload"
                              title="Admin Edit Prop"
                              style={{ zIndex: 1 }}
                            >
                              <span
                                id={photos.id}
                                className="material-icons"
                                onClick={(e) => setObjectPopup(e)}
                                style={{ fontSize: "14px", lineHeight: "12px" }}
                              >
                                edit
                              </span>
                            </div>
                            <div
                              className="adminIconsDelete"
                              title="Admin Prop Delete"
                              style={{ zIndex: 1 }}
                            >
                              <span
                                id={photos.id}
                                className="material-icons"
                                onClick={deleteShape}
                                style={{ fontSize: "14px", lineHeight: "12px" }}
                              >
                                delete
                              </span>
                            </div>
                          </>
                        )}
                        <div
                          style={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "25px",
                          }}
                        >
                          <img
                            key={"img" + photos.id}
                            src={
                              authenticationData.ApiBaseURL +
                              "/" +
                              photos.shapePath
                            }
                            alt=""
                            draggable={false}
                            style={{
                              padding: "2px",
                              borderRadius: "7px",
                              width: "100%",
                              height: "100%",
                              position: "absolute",
                              left: "0px",
                            }}
                            onClick={(e) => {
                              addshape(e, photos.shapePath);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* <div style={{ width: "50%" }}>
                    {props.item.map((photos, index) => {
                      return (
                        index % 2 != 0 && (
                          <div
                            key={index}
                            className="dragdivParent ShapeHover"
                            style={{
                              display: "inline-block",
                              width: "163px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100px",
                                borderRadius: "25px",
                              }}
                            >
                              <span
                                id={photos.id}
                                onClick={(e) => setObjectPopup(e)}
                                className="material-icons"
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  right: "0px",
                                  color: "#9f9393",
                                }}
                              >
                                edit
                              </span>
                              <span
                                onClick={deleteShape}
                                id={photos.id}
                                className="material-icons"
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  right: "25px",
                                  color: "#9f9393",
                                }}
                              >
                                delete
                              </span>
                              <img
                                key={"img" + photos.id}
                                src={
                                  authenticationData.ApiBaseURL +
                                  "/" +
                                  photos.path
                                }
                                alt=""
                                draggable={false}
                                style={{
                                  padding: "2px",
                                  borderRadius: "7px",
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                }}
                                onClick={(e) => {
                                  addshape(
                                    e,
                                    authenticationData.ApiBaseURL +
                                      "/" +
                                      photos.path
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div> */}
              </div>
            )}
            {props.item.length == 0 && (
              <div className="Asset_items" style={{ margin: "0 auto" }}>
                <div
                  className="Asset_items_start"
                  style={{ textAlign: "center" }}
                >
                  No Record found...
                </div>
              </div>
            )}
            {open === true && (
              <UpdateTags
                itemId={itemId}
                type={props.type}
                open={open}
                setOpen={setOpen}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AssetSearch;
